var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_2845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.48865 7.31129C5.76925 7.31129 6.80738 6.27316 6.80738 4.99256C6.80738 3.71196 5.76925 2.67383 4.48865 2.67383C3.20805 2.67383 2.16992 3.71196 2.16992 4.99256C2.16992 6.27316 3.20805 7.31129 4.48865 7.31129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63088 4.99299C6.6256 5.87682 6.06748 6.70079 5.22943 7.00361C4.37553 7.31172 3.416 7.04939 2.83323 6.35394C2.25751 5.66554 2.19061 4.64967 2.65365 3.8838C3.11141 3.12498 4.02693 2.71299 4.9002 2.88905C5.7805 3.06512 6.46186 3.77817 6.60623 4.66375C6.6256 4.77291 6.63088 4.88383 6.63088 4.99299C6.63264 5.22011 6.98476 5.22011 6.983 4.99299C6.97772 3.94718 6.31573 3.00702 5.33507 2.64609C4.36497 2.29045 3.22585 2.60031 2.5709 3.39963C1.90715 4.20952 1.8068 5.3768 2.35083 6.27824C2.89486 7.17967 3.96531 7.64271 4.99351 7.43496C5.98826 7.23601 6.79638 6.3962 6.94955 5.39089C6.96892 5.25884 6.98124 5.12504 6.983 4.99123C6.98476 4.76587 6.63264 4.76587 6.63088 4.99299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_2845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.3ce8fffde0c45c2ef6fc0dc63d8d83c5.svg";
export { ForwardRef as ReactComponent };